var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-1",attrs:{"cols":_vm.cols,"sm":_vm.sm,"md":_vm.md}},[_c('label',{staticClass:"form-label"},[_vm._v(_vm._s(_vm.label))]),_c('v-text-field',{attrs:{"dense":"","readonly":"","outlined":"","filled":"","background-color":_vm.bgColor,"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }